import { Layout, Rect, type Node } from "@revideo/2d";
import { HEIGHT, WIDTH, incomingMotionValues, outgoingMotionValues, type CutStyle } from "@hudhud/reel/math";
import { motionProps } from "./video";

/** A whole layer arriving with a transition over its first `frames` frames (the video after the opener, the end card after the video). */
export function arriveWith(style: CutStyle, frames: number, index: number, lite: boolean, frame: () => number, child: Node): Node {
  const m = () => (frames > 0 ? incomingMotionValues(style, frame() / frames, index, lite) : { motion: {}, overlayOpacity: 0, overlayColor: "#fff" });
  return new Layout({
    width: WIDTH, height: HEIGHT,
    opacity: () => motionProps(m().motion).opacity, position: () => motionProps(m().motion).position,
    scale: () => motionProps(m().motion).scale, filters: () => motionProps(m().motion).filters,
    children: [child, new Rect({ width: WIDTH, height: HEIGHT, fill: () => m().overlayColor, opacity: () => m().overlayOpacity })],
  });
}

/** A whole layer leaving with a transition: `t` runs 0..1 from `from` over `frames` frames of the layer's own clock. */
export function leaveWith(style: CutStyle, from: number, frames: number, index: number, lite: boolean, frame: () => number, child: Node): Node {
  const m = () => outgoingMotionValues(style, frames > 0 ? (frame() - from) / frames : 0, index, lite);
  return new Layout({
    width: WIDTH, height: HEIGHT,
    opacity: () => motionProps(m()).opacity, position: () => motionProps(m()).position,
    scale: () => motionProps(m()).scale, filters: () => motionProps(m()).filters,
    children: [child],
  });
}
